<template>
    <div id="congreso">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="18" class="titulo">
                <strong>IV CONGRESO INTERNACIONAL DE EDUCACIÓN</strong><br>
                La Educación del Mundo se Conecta en Tucumán
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="22" class="cuerpo">


                <!-- APROBADO -->
                <div v-if="Aprobado">
                    <div style="width:100%; text-align:center; color:#fff; padding:10px; background-color:green; font-size:large; margin-bottom:30px">
                        <strong>CONGRESO APROBADO</strong><br><br>
                        <strong>Código #{{ Codigo }}</strong><br><br>
                        Muchas Gracias por haber participado.
                    </div>
                    <img 
                        src="https://docentes.educaciondigitaltuc.gob.ar/assets/LogoCongreso.png" 
                        style="width:100%"
                    />
                </div>


                <!-- NO FIGURA APROBADO -->
                <div v-if="!Aprobado">
                    <el-col :xs="24" :sm="12" v-for="(bloque, index) in Bloques" :key="index" style="margin-bottom:30px">
                        <div style="width:100%; text-align:center; font-weight:bold; color:#fff; padding:10px; background-color:#2A5DAF">
                            Evaluativo {{ index }}º Bloque
                        </div>
                        <img 
                            src="https://docentes.educaciondigitaltuc.gob.ar/assets/LogoCongreso.png" 
                            style="width:100%"
                        /> 


                        <!-- Cuestionario sin Responder -->
                        <div v-if="bloque.Respondidas==0" style="width:100%; text-align:center; font-weight:bold; color:#fff; padding:10px; background-color:#2A5DAF">
                            Cuestionario sin Responder
                            <br><br>
                        </div>


                        <!-- Cuestionario Inconcluso -->
                        <div v-if="bloque.Respondidas>0 && bloque.Respondidas<bloque.Total" style="width:100%; text-align:center; font-weight:bold; color:#fff; padding:10px; background-color:orange">
                            Cuestionario Inconcluso.
                            <br><br>
                        </div>


                        <!-- Desaprobado en la Primera - Sin Recuperar -->
                        <div v-if="bloque.Respondidas==bloque.Total && bloque.RespondidasCorrectas<bloque.Total && bloque.Recuperadas==0" style="width:100%; text-align:center; color:#fff; padding:10px; background-color:red; font-size:12px">
                            <strong>DESAPROBADO</strong><br>
                            {{ bloque.RespondidasCorrectas }} de {{ bloque.Total }} respuestas correctas.
                            <br><br>
                        </div>


                        <!-- Desaprobado en la Primera - Recuperacion a Medias -->
                        <div v-if="bloque.Respondidas==bloque.Total && bloque.RespondidasCorrectas<bloque.Total && bloque.Recuperadas>0 && bloque.Recuperadas<5 && bloque.RecuperadasCorrectas<5" style="width:100%; text-align:center; color:#fff; padding:10px; background-color:red; font-size:12px">
                            <strong>DESAPROBADO</strong><br>
                            {{ bloque.RespondidasCorrectas }} de {{ bloque.Total }} respuestas correctas.
                            <br><br>
                        </div>


                        <!-- Desaprobado en la Recuperacion -->
                        <div v-if="bloque.Respondidas==bloque.Total && bloque.RespondidasCorrectas<bloque.Total && bloque.Recuperadas==5 && bloque.RecuperadasCorrectas<5" style="width:100%; text-align:center; color:#fff; padding:10px; background-color:red; font-size:12px">
                            <strong>DESAPROBADO</strong><br>
                            {{ bloque.RecuperadasCorrectas }} de 5 respuestas correctas.
                            <br><br>
                        </div>


                        <!-- Aprobado en la Recuperacion -->
                        <div v-if="bloque.Respondidas==bloque.Total && bloque.RespondidasCorrectas<bloque.Total && bloque.Recuperadas==5 && bloque.RecuperadasCorrectas==5" style="width:100%; text-align:center; color:#fff; padding:10px; background-color:green; font-size:13px">
                            <strong>APROBADO</strong><br>
                            {{ bloque.RecuperadasCorrectas }} de 5 respuestas correctas.
                            <br><br>
                        </div>


                        <!-- Aprobado a la Primera -->
                        <div v-if="bloque.Respondidas==bloque.Total && bloque.RespondidasCorrectas==bloque.Total" style="width:100%; text-align:center; color:#fff; padding:10px; background-color:green">
                            <strong>APROBADO</strong><br>
                            {{ bloque.RespondidasCorrectas }} de {{ bloque.Total }} respuestas correctas.
                            <br><br>
                        </div>
                    </el-col>
                </div>

            </el-col>        
        </el-row>
    </div>
</template>


<script>
    import axios from 'axios';

    export default
    {   data()
        {   return {
                Aprobado:   false,
                Codigo:     0,
                Bloques:    [],
            }
        },

        beforeMount()
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/congreso3.php', params, {headers: headers})
                    .then(response => {
                        const datos         = response.data;
                        if(datos['Aprobado'])
                        {   this.Aprobado   = true;
                            this.Codigo     = datos['Codigo'];
                        }
                        else
                        {   this.Bloques    = datos;
                        }
                    })
                    /*.catch(e => {})*/
            }
        }
    }
</script>


<style>
</style>
